import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
export function CTASection() {
  return <section id="contact" className="relative py-24 overflow-hidden" data-id="element-25" data-mp="27hoywjm8k8ic">
      {/* Background Image & Overlays */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1542884748-2b87b36c6b90?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=90)'
    }} data-id="element-26" data-mp="2ce5kp75yqas9"></div>
      <div className="absolute inset-0 bg-brand-navy/95 mix-blend-multiply" data-id="element-27" data-mp="2qeq68b39ikpg"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/90 to-brand-navy/80" data-id="element-28" data-mp="2v5pzn6d6akn7"></div>

      {/* Decorative Gold Accents */}
      <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-29" data-mp="304jd4ysgmbnd"></div>
      <div className="absolute -right-20 -top-20 w-64 h-64 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-30" data-mp="355p7t25ok8zj"></div>
      <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-31" data-mp="3a4a6uy974mme"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-32" data-mp="217t8w18f13ku">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-33" data-mp="1w6dl41eusiyr">
          Ready to transform your <br className="hidden md:block" data-id="element-34" data-mp="1ra52ge1g67mu" />
          <span className="text-brand-gold italic" data-id="element-35" data-mp="1n6z21n10naoa">managed care program?</span>
        </h2>
        <p className="text-lg text-white/80 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-36" data-mp="2jx9bqv7kp84f">
          Connect with our team of experts to discuss how Arissa Cost Solutions
          can drive better outcomes for injured workers and measurable savings
          for your organization.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-37" data-mp="265urym5ud2wb">
          <Link to="/contact" className="inline-flex items-center justify-center bg-brand-gold text-brand-navy px-8 py-4 rounded font-semibold text-lg hover:bg-white transition-colors shadow-[0_0_20px_rgba(201,162,75,0.3)] w-full sm:w-auto" data-id="element-38" data-mp="32o96kd1r1c5m">
            Schedule a Meeting With Us
          </Link>
          <a href="tel:7142591053" className="flex items-center justify-center text-white border border-white/30 px-8 py-4 rounded font-semibold text-lg hover:bg-white/10 transition-colors w-full sm:w-auto backdrop-blur-sm" data-id="element-39" data-mp="10xa1lydex9t5">
            <Phone className="w-5 h-5 mr-2" data-id="element-40" data-mp="d87l4tuiln08" />
            Call 714.259.1053
          </a>
        </div>
      </div>
    </section>;
}